<template>
	<c-dialog ref="dialog" width="100vw-300" mode="slide" mask-close @close="dialogFormEditConfirm($refs.inventoryForm, arguments)" @resolve="editHandle">
		<c-form ref="inventoryForm" column="3" vertical unit-width="100%">
			<c-title>基本信息</c-title>
			<c-form link-parent>
				<c-form-column>
					<c-form-item label="单据编号">
						<c-input name="order_code" placeholder="请输入，忽略将自动生成"></c-input>
					</c-form-item>
					<c-form-item label="盘点时间" required>
						<c-datetime name="storage_date" type="datetime" format="yyyy-MM-dd hh:mm" time-accuracy="min" placeholder="请选择实际盘点时间" v-model="storage_date"></c-datetime>
					</c-form-item>
				</c-form-column>

				<c-form-column>
					<c-form-item label="仓库" required>
						<c-select ref="warehouse" name="warehouse_id" v-model="warehouse_id" async @search="searchWarehouse"  :value-data="warehouseOptions" :disabled="this.order_id>0"  :clear="false"></c-select>
						<template #handle>
							<c-tooltip tip="仓库切换将清空盘点明细商品，请谨慎操作" position="top"></c-tooltip>
						</template>
					</c-form-item>
					<c-form-item label="盘点类型" required>
						<c-select name="order_classify" :options="inventoryClassifyName" :clear="false"></c-select>
					</c-form-item>
				</c-form-column>

				<c-form-column>
					<c-form-item label="备注">
						<c-input type="textarea" name="remark"></c-input>
					</c-form-item>
				</c-form-column>

				<!--自定义字段-->
				<custom-form ref="customForm" work-type="20"></custom-form>
			</c-form>
			<c-title >盘点明细</c-title>
			<c-form-item name="product_list" :label="false" colspan="3">
				<custom-table ref="productTable" :view-id="view_id" work-type="21">
					<template #operate>
						<c-button color="main" v-if="(auth('b_inventory_edit') || auth('b_inventory_create')) && systemConfig.batch_stock == 1" v-lock="lock('b_inventory_edit')" prepend-icon="tf-add" @click="selectProductBatch()">选择产品批次库存</c-button>
						<c-button color="main" v-else-if="(auth('b_inventory_edit') || auth('b_inventory_create'))" v-lock="lock('b_inventory_edit')" prepend-icon="tf-add" @click="selectProduct()">选择产品</c-button>
					</template>
					<!--产品来源-->
					<template #product_source="{data}">
						<c-state dict="productSourceName" :value="data.product_source"></c-state>
					</template>
					<!--商品类型-->
					<template #product_type="{data}">
						<c-state dict="productTypeName" :value="data.product_type"></c-state>
					</template>
					<!--盘点数量-->
					<template #view_product_count="{data}">
						<c-input name="view_product_count" type="stepper" decimal="6" :range="[0,99999999]" v-model="data.view_product_count" @change="changeViewCount(data)"></c-input>
					</template>

					<c-table-column
                        type="button"
                        label="操作"
                    >
                        <template #default="{data,remove}">
							<c-table-button v-if="auth('b_inventory_edit')" v-lock="lock('b_inventory_edit')" icon="tf-trash" color="red" @click="removeRow(data,remove)">删除</c-table-button>
						</template>
					</c-table-column>
				</custom-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
	name: 'b_inventory_edit',
	computed: {
		// 获取dictName选项数据
		...mapState(['inventoryClassifyName', 'systemConfig']),
	},
	// 监听器
	watch: {
		//仓库变更，清除商品列表
		warehouse_id() {
			if (this.order_id == 0 || !this.order_id){
				this.$refs.productTable.$refs.list.setData([]);
			}
		}
	},

	data() {
		return {
			view_id:10007,
			order_id:0,
			storage_date:'',
			deleteProductList:[],
			warehouseOptions:[],
			warehouse_id:0
		}
	},
	methods: {
		/************打开新增、编辑弹窗**************/
		open(data) {
			//自定义字段控件初始化
			this.$refs.customForm.init();
			//初始化产品列表控件
			this.$refs.productTable.init();

			this.deleteProductList = [];
			this._editState = !!data;
			this.$refs.inventoryForm.clear();
			if (data) {
				this.order_id = data.id;
				this.getDetail();
			}else {
				this.order_id = 0;
				this.$refs.inventoryForm.set({
					storage_date: new Date().format('yyyy-MM-dd hh:mm'),
					order_classify: 30
				});
				//选中默认仓库
				this.getDefaultWarehouse();
			}
			this.$refs.dialog.open({
				title: data ? '编辑盘点单' : '创建盘点单'
			});
		},

		/*******搜索盘点单详情*******************/
		getDetail() {
			this.request({
				url:'/inventory/order/detail',
				data: {
					id: this.order_id
				},
				loading: true,
				success: data => {
					this.$refs.inventoryForm.set(data);
					this.storage_date = data.storage_date;
					if (data && data.warehouse_id && data.warehouse_name){
						this.warehouseOptions = [{
							name:data.warehouse_name + ' | ' + data.warehouse_code,
							value:data.warehouse_id
						}];
					}else {
						this.warehouseOptions = [];
					}
					//查询产品列表
					this.getProductList();
				}
			});
		},

		/*********加载商品列表******************/
		getProductList() {
			this.request({
				url:'/inventory/order/product/list',
				data: {
					view_id:this.view_id,
					id: this.order_id
				},
				loading: true,
				success: data => {
					var productList = data.map(item => {
						var obj = item;
						obj.is_db = 1;
						obj.old_product_count = item.view_product_count||0;
						return obj;
					});
					//加载工单列表
					this.$refs.productTable.$refs.list.setData(productList);
				}
			});
		},

		/***
		 **查询默认仓库
		 **/
		getDefaultWarehouse(){
			this.request({
				url:'/system/options',
				data: {
					options_code:'WAREHOUSE'
				},
				success:data => {
					if (data.length == 1){
						this.warehouseOptions = [data[0]];
						this.warehouse_id = data[0].value;
					}
				}
			});
		},

		/*******搜索【仓库】下拉框信息*****************/
		searchWarehouse(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'WAREHOUSE',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******变更输入框内容事件****************/
		changeViewCount(rowData){
			var product_original_count = rowData.product_original_count||0;
			if (isNaN(product_original_count)) {
				product_original_count = 0;
			}
			var view_product_count = rowData.view_product_count||0;
			if (isNaN(view_product_count)) {
				view_product_count = 0;
			}
			rowData.product_new_count = parseFloat(view_product_count) - parseFloat(product_original_count);
		},

		/******删除行数据********/
		removeRow(data, remove) {
			if (data.is_db == 1 && data.id && data.id > 0){
				this.deleteProductList.push(data.id);
			}
			remove();
		},

		/******打开选择产品弹窗*********/
		selectProduct(){
			if (this.warehouse_id == 0){
				this.$message({
					message:'请选择盘点仓库',  // 提示内容,
					type: 'warn'
				});
			}else {
				this.globalDialog('productSelector', {
					props: {
						warehouseOptions: [this.$refs.warehouse.getData()]
					}
				}, this.productSelectorHandle)
			}
		},

		/******选择产品响应方法*********/
		async productSelectorHandle(data) {
			//判断是否已存在于表格之中，已存在则不允许添加
			for (var i = 0; i < data.length; i++) {
				var newProduct = data[i];
				var existObj = this.$refs.productTable.$refs.list.getData().find(function (obj) {
					return obj.product_id == newProduct.id
				});
				if (existObj){
					this.$message({
						type:'warn',
						message:'产品【'+existObj.product_code+' | '+existObj.product_name+'】已存在，请勿重复添加',
					});
					return;
				}
			}
			
			//处理数据
			this.$refs.productTable.$refs.list.push(
				await this.$refs.productTable.setDefaultData(data.map(item => {
					return Object.assign({}, item, {
						product_id: item.id,
						product_original_count: item.product_count,
						product_new_count: item.product_count,
						id: null,//ID置空
						custom_fields_value_json: {}//自定义参数置空
					});
				}), {
					work_type_id: 21,
					source_list: data.map(item => {
						return [{
							ref_work_type_id: 7,
							ref_id: item.product_id
						}]
					})
				})
			);
		},
		
		/******打开选择产品批次库存弹窗*********/
		selectProductBatch(){
			if (this.warehouse_id == 0){
				this.$message({
					message:'请选择出库仓库',  // 提示内容,
					type: 'warn'
				});
			}else {
				this.globalDialog('productBatchSelector', {
					props: {
						warehouseOptions: [this.$refs.warehouse.getData()],
						isStock: true,
						disabledWarehouse: true
					}
				}, this.productBatchSelectorHandle)
			}
		},
		
		/******选择产品批次库存响应方法*********/
		async productBatchSelectorHandle(data) {
			//判断是否已存在于表格之中，已存在则不允许添加
			for (var i = 0; i < data.length; i++) {
				var newProduct = data[i];
				var existObj = this.$refs.productTable.$refs.list.getData().find(function (obj) {
					return obj.product_id == newProduct.product_id && obj.batch_id == newProduct.batch_id
				});
				if (existObj){
					this.$message({
						type:'warn',
						message:'产品【'+existObj.product_code+' | '+existObj.product_name+'】,批次【' + existObj.batch_code + '】已存在，请勿重复添加',
					});
					return;
				}
			}
			//处理数据
			this.$refs.productTable.$refs.list.push(
				await this.$refs.productTable.setDefaultData(data.map(item => {
					return Object.assign({}, item, {
						product_id: item.product_id,
						product_original_count: item.product_count,
						product_new_count: item.product_count,
						id: null,//ID置空
						custom_fields_value_json: {}//自定义参数置空
					});
				}), {
					work_type_id: 21,
					source_list: data.map(item => {
						return [{
							ref_work_type_id: 7,
							ref_id: item.product_id
						}]
					})
				})
			);
		},

		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			//盘点商品
			var product_list = this.$refs.productTable.$refs.list.getData();
			this.$refs.inventoryForm.submit({
				url: this.order_id==0?'/inventory/order/add':'/inventory/order/edit',
				rule: {
					warehouse_id: '请选择盘点仓库',
					order_classify: '请选择盘点类型',
					storage_date: '请选择盘点时间',
					product_list: data => {
						var flag = true;
						if(product_list.length == 0) return "请添加产品明细";
						product_list.forEach(item => {
							if(!item.view_product_count || isNaN(item.view_product_count)){
								flag = false;
							}
						});
						if (!flag) {
							return '请完善产品明细';
						}
						//自定义字段校验
						return this.$refs.productTable.validate();
					},
					...this.$refs.customForm.rule
				},
			    dataFormatter: data => {
					data.id = this.order_id||0;
				    data.product_list  = product_list.map(item => {
					    return {
						    id:item.id,
						    product_id:item.product_id,
							batch_id: item.batch_id||0,
						    old_product_count:item.old_product_count,
						    view_product_count:item.view_product_count,
						    product_original_count:item.product_original_count,
						    custom_fields_value_json: JSON.stringify(item.custom_fields_value_json)
					    }
				    });
					data.delete_product_list = this.deleteProductList;
				    data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
				    return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message:this._editState ? '编辑盘点单成功' : '创建盘点单成功',
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>